const X_VEHICLE_TYPE = "CAR";
const X_COUNTRY = "AU";
let UPLOAD_API_URL = "https://b2c-bff-au.qac24svc.dev/";
let BASE_API_URL = "https://b2c-bff-au.qac24svc.dev/vo/";
let WORKSHOP_API_URL = "https://b2c-bff-au.qac24svc.dev/parts/";
let REFURB_SERVICES_API_URL = "https://b2c-bff-au.qac24svc.dev/refurb";

switch (process.env.REACT_APP_ENV) {
  case "DEVELOPMENT":
    UPLOAD_API_URL = "https://b2c-bff-au.qac24svc.dev/";
    BASE_API_URL = "https://b2c-bff-au.qac24svc.dev/vo/";
    WORKSHOP_API_URL = "https://b2c-bff-au.qac24svc.dev/parts/";
    REFURB_SERVICES_API_URL = "https://b2c-bff-au.qac24svc.dev/refurb";
    break;
  case "QA":
    UPLOAD_API_URL = "https://b2c-bff-au.qac24svc.dev/";
    BASE_API_URL = "https://b2c-bff-au.qac24svc.dev/vo/";
    WORKSHOP_API_URL = "https://b2c-bff-au.qac24svc.dev/parts/";
    REFURB_SERVICES_API_URL = "https://b2c-bff-au.qac24svc.dev/refurb";
    break;
  case "STAGING":
    UPLOAD_API_URL = "https://stage-b2c-bff-au.qac24svc.dev/";
    BASE_API_URL = "https://stage-b2c-bff-au.qac24svc.dev/vo/";
    WORKSHOP_API_URL = "https://stage-b2c-bff-au.qac24svc.dev/parts/";
    REFURB_SERVICES_API_URL = "https://stage-b2c-bff-au.qac24svc.dev/refurb";
    break;
  case "PRODUCTION":
    UPLOAD_API_URL = "https://b2c-bff-au.c24.tech/";
    BASE_API_URL = "https://b2c-bff-au.c24.tech/vo/";
    WORKSHOP_API_URL = "https://b2c-bff-au.c24.tech/parts/";
    REFURB_SERVICES_API_URL = "https://b2c-bff-au.c24.tech/refurb";
    break;
  default:
}

const apiConstants = {
  X_VEHICLE_TYPE,
  X_COUNTRY,
  BASE_API_URL,
  WORKSHOP_API_URL,
  REFURB_SERVICES_API_URL,
  UPLOAD_API_URL
};

export default apiConstants;
